import { OccasionsEnum, BundleDetails } from '@/types/bundles.types';
import { TFunction } from 'i18next';

export const formatOccasion = {
  DINE_IN: 'Dine-In',
  DRIVE_THRU: 'Drive-Thru',
  CARRYOUT: 'Carryout',
  DELIVERY: 'Delivery',
};

export const renderOccasions = (t: TFunction, occasions?: OccasionsEnum[]) => {
  if (!occasions) return '-';
  if (occasions.length === 4 || occasions.length === 0) return t('common.all');
  return occasions.map((item) => t(`occasions.${item}`)).join(', ');
};

export const renderLockedSettings = (data?: BundleDetails) => {
  const { isLockRedeemableOnline, isLockVisibleOnline, lockRedeemableOnline, lockVisibleOnline, isLockPrice } =
    data || {};

  let strString = '';
  if (!isLockRedeemableOnline && !isLockVisibleOnline) {
    strString = '';
  }
  if (isLockRedeemableOnline && isLockVisibleOnline) {
    strString = `Online redemption: ${lockRedeemableOnline ? 'Yes' : 'No'}, Online visibility: ${
      lockVisibleOnline ? 'Yes' : 'No'
    }`;
  } else if (isLockVisibleOnline) {
    strString = `Online visibility: ${lockVisibleOnline ? 'Yes' : 'No'}`;
  } else if (isLockRedeemableOnline) {
    strString = `Online redemption: ${lockRedeemableOnline ? 'Yes' : 'No'}`;
  }

  if (isLockPrice) {
    if (strString) {
      return `Price Locked, ${strString}`;
    }
    return 'Price Locked';
  }
  return strString;
};
